import { TFunction } from 'i18next';
import { TableColumn, TableStyles } from 'react-data-table-component';
import { NavigateFunction } from 'react-router-dom';
import { WfProduct } from 'src/api/wf/models/WfProduct';
import LinkButton from 'src/ui/wf/common/button/LinkButton';
import { WfScreensMap } from 'src/ui/wf/router/WfScreensMap';
import { wfNavigate } from 'src/ui/wf/router/WfScreenRegistration';
import { WF_Screen } from 'src/ui/wf/router/WfScreens';
import { getOperationStatusTranslationKey } from 'src/api/wf/models/enums/WfOperationtStatus';

export const productTableStyle: TableStyles = {
  table: {
    style: {
      backgroundColor: '#f8f8f8',
      borderTop: '2px solid #c026d3',
      padding: '10px',
      borderRadius: '4px',
    },
  },
  headCells: {
    style: {
      backgroundColor: '#f2f3f3',
      borderInline: '1px solid #e3e6e7',
      borderTop: '1px solid #e3e6e7',
      fontWeight: 700,
    },
  },
  rows: {
    style: {
      borderRight: '1px solid #e3e6e7',
      borderBottom: '1px solid #e3e6e7',
      borderLeft: '1px solid #e3e6e7',
    },
  },
};

export const productDataColumns = (
  t: TFunction,
  navigate: NavigateFunction,
  setSelectedProduct: (selectedProduct: WfProduct | null) => void
): TableColumn<WfProduct>[] => {
  return [
    {
      id: 'productNumber',
      name: t('wf.siteDetails.SEnumber'),
      selector: (r) => r.productNumber?.toString() ?? '',
      cell: (row) => (
        <LinkButton
          title={`${row.productNumber}`}
          onClick={() => {
            setSelectedProduct(row);
            wfNavigate(navigate, WfScreensMap[WF_Screen.PropertyStatusRegistration].path);
          }}
          className="text-left"
        />
      ),
      sortable: true,
    },
    {
      id: 'unit',
      name: t('wf.siteDetails.unit'),
      selector: (_row) => String(_row.unit),
      sortable: true,
      width: '6rem',
    },
    {
      id: 'latestState',
      name: t('wf.siteDetails.latestState'),
      selector: (_row) =>
        _row.statusName ? t(getOperationStatusTranslationKey(_row.statusName)) : '',
      sortable: true,
    },
    {
      id: 'contract',
      name: t('wf.siteDetails.contract'),
      selector: (_row) => String(_row.contractName),
      sortable: true,
      width: '8.5rem',
    },
    {
      id: 'model',
      name: t('wf.siteDetails.deviceModel'),
      selector: (_row) => String(_row.model),
      sortable: true,
      width: '20rem',
    },
  ];
};
